module.exports = __webpack_public_path__ + "img/livepilot_img.91117f2e.png";